import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

// Create axios instance with default config
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add request interceptor to include token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('customerToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid
            localStorage.removeItem('customerToken');
            localStorage.removeItem('customerUser');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Authentication API
export const authAPI = {
    login: (email, password) => api.post('/api/portal/auth/login', { email, password }),
    logout: () => api.post('/api/portal/auth/logout'),
    getMe: () => api.get('/api/portal/auth/me'),
    forgotPassword: (email) => api.post('/api/portal/auth/forgot-password', { email }),
    resetPassword: (token, newPassword) => api.post('/api/portal/auth/reset-password', { token, newPassword }),
    changePassword: (currentPassword, newPassword) => api.post('/api/portal/auth/change-password', { currentPassword, newPassword })
};

// Customer data API
export const customerAPI = {
    getProfile: () => api.get('/api/portal/customer/profile'),
    updateProfile: (data) => api.put('/api/portal/customer/profile', data),
    getDashboard: () => api.get('/api/portal/customer/dashboard'),
    
    getInvoices: (params) => api.get('/api/portal/customer/invoices', { params }),
    getInvoice: (id) => api.get(`/api/portal/customer/invoices/${id}`),
    
    getTickets: (params) => api.get('/api/portal/customer/tickets', { params }),
    getTicket: (id) => api.get(`/api/portal/customer/tickets/${id}`),
    createTicket: (data) => api.post('/api/portal/customer/tickets', data),
    addTicketComment: (id, comment) => api.post(`/api/portal/customer/tickets/${id}/comments`, { comment }),
    
    getContracts: () => api.get('/api/portal/customer/contracts'),
    getContract: (id) => api.get(`/api/portal/customer/contracts/${id}`),
    
    getAssets: () => api.get('/api/portal/customer/assets'),

    getDocuments: () => api.get('/api/portal/customer/documents'),

    getDomains: (params) => api.get('/api/portal/customer/domains', { params }),
    getDomain: (id) => api.get(`/api/portal/customer/domains/${id}`),
    toggleDomainAutoRenew: (id, enabled) => api.post(`/api/portal/customer/domains/${id}/auto-renew`, { enabled }),
    getDomainAuthCode: (id) => api.get(`/api/portal/customer/domains/${id}/auth-code`),
    renewDomain: (id, years = 1) => api.post(`/api/portal/customer/domains/${id}/renew`, { years })
};

export default api;
